module.exports = __webpack_public_path__ + "static/media/mapnode-skifahren-premium.6a9d49e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/assets/mapnode-skifahren-premium.svg
// module id = 319
// module chunks = 0